<!--商品详情-->
<template>
  <div class="img-container" v-loading="loading">
    <div
      class="wrapper"
      v-for="(item, index) in imgList"
      :key="index"
      style="position: relative"
    >
      <!-- <img :src="item" class="img" /> -->
      
      <div class="iconWrap">
        <!-- <svg
          class="closeIcon"
          aria-hidden="true"
          @click="upSort(index)"
          v-if="index !== 0"
        >
          <use xlink:href="#icon-up"></use>
        </svg> -->
        <!-- <svg
          class="closeIcon"
          aria-hidden="true"
          @click="downSort(index)"
          v-if="index !== imgList.length - 1"
        >
          <use xlink:href="#icon-down"></use>
        </svg> -->
        <svg class="closeIcon" aria-hidden="true" @click="deletePic(index)">
          <use xlink:href="#icon-photo-close"></use>
        </svg>
      </div>
      <el-image
        :src="item"
        class="img"
        :z-index="10"
        style="position: relative;"
        :preview-src-list="[item]"
      >
      </el-image>
    </div>
    <div class="btn-add">
      <input
        type="file"
        class="add"
        @change="addImg"
        ref="inputImg"
        accept="image/gif, image/jpeg, image/png, image/jpg"
        multiple
      />
      <p>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-xinzeng1"></use>
        </svg>
      </p>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'img-uploader',

  data() {
    return {
      value: [],
      loading: false, // 页面加载
      picList: [], // 上传oss图片列表
      iconShow: [],
      imgList: this.imageList // 预览图片列表
    };
  },
  props: {
    imageList: {
      type: Array
    },
    maxPicNum: {
      required: true,
      type: Number,
      default: -1
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    showIcon(index) {
      this.$set(this.iconShow, index, true);
    },
    hideIcon(index) {
      this.$set(this.iconShow, index, false);
    },
    upSort(index) {
      // 上调顺序
      this.loading = true;
      let img = this.imgList[index - 1];
      this.imgList[index - 1] = this.imgList[index];
      this.imgList[index] = img;
      this.loading = false;
    },
    downSort(index) {
      // 下调顺序
      this.loading = true;
      let img = this.imgList[index + 1];
      this.imgList[index + 1] = this.imgList[index];
      this.imgList[index] = img;
      this.loading = false;
    },
    getPics() {
      this.$emit('getDetail', this.imgList);
    },
    async addImg(e) {
      // 鉴别上传重复图片
      let value = this.$refs.inputImg.value;
      // if (this.value.includes(value)) {
      //     this.$message({
      //         message: '图片上传重复，请重新选择！',
      //         type: 'warning'
      //     });
      //     return;
      // }
      let files = e.target.files;
      let num = 0;
      this.loading = true;
      for (let i in files) {
        if (!files[i].name) {
          return;
        }
        await this.request.upPic({ prefix: 'goods', file: files[i] }).then(
          (res) => {
            this.imgList.push(res);
            num++;
            if (num >= files.length) {
              this.$message({
                message: '图片上传成功',
                type: 'success'
              });
              this.loading = false;
              // 将当前的value赋给this.value,将value置空，避免input重复上传图片不触发change事件
              this.value.push(value);
              this.$refs.inputImg.value = '';
              // 图片上传完成向父组件传递
              this.iconShow = new Array(this.imgList.length).fill(false);
              this.getPics();
            }
          },
          (res) => {
            this.$message({
              message: '第' + i + '图片上传失败',
              type: 'error'
            });
            this.loading = false;
          }
        );
      }
    },
    deletePic(index) {
      this.imgList.splice(index, 1);
      this.getPics();
    }
  },
  watch: {
    imageList(val) {
      this.imgList = val;
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.title {
  flex-center();
  justify-content: flex-start;
  word-main();
  height: cell-height;
  padding-left: 10px;
}

.img-container {
  flex-x();
  background: white;
  justify-content: flex-start;
  flex-wrap: wrap;
  box-sizing: border-box;
  margin-top: 20px;

  .wrapper {
    width: auto;
    height: 120px;
    margin-right: 12px;
    margin-bottom: 12px;

    .img {
      width: auto;
      height: 100%;
    }

    .iconWrap {
      flex-center();
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      // z-index : 0;

      // background: black;
      // opacity: 0.5;
      .closeIcon {
        fill: gray6;
        background-color: white;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        position: absolute;
        top: -10px;
        right: -10px;
        cursor: pointer;
        z-index :2;
      }
    }
  }

  .btn-add {
    margin-right: 12px;
    margin-bottom: 12px;
    flex-y();
    width: 120px;
    height: 120px;
    // padding: 10px 0;
    background: white;
    box-sizing: border-box;
    border();
    font-size: 10px;
    color: gray6;
    position: relative;
    background: #f6f6f6;
    border-color: #E8E8E8;

    .add {
      width: 100%;
      height: 100%;
      opacity: 0;
      position: absolute;
      color: #979797;
    }
  }
}

.icon {
  fill: #979797;
  width: 42px;
  height: 42px;
}
</style>
